import { getWsBasePath } from "../utils";

export const WHATSAPP_ACCOUNT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/WHATSAPP/ACCOUNT`;
export const WHATSAPP_CONTACT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/WHATSAPP/CONTACT`;
export const WHATSAPP_CHAT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/WHATSAPP/CHAT`;
